__turbopack_context__.v({
  "bold": "R-7DYW_bold",
  "buttonContainer": "R-7DYW_buttonContainer",
  "buttonCopy": "R-7DYW_buttonCopy",
  "columns": "R-7DYW_columns",
  "container": "R-7DYW_container",
  "label": "R-7DYW_label",
  "notes": "R-7DYW_notes",
  "rows": "R-7DYW_rows",
});
